import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

class ConfirmCancel extends React.Component {

    static propTypes = {
      onCancel: PropTypes.func,
      onOk: PropTypes.func,
      isSave: PropTypes.bool,
      data: PropTypes.any,
      templateId: PropTypes.any,
      onEditCustomTemplate: PropTypes.func,
      onCloseAfterSave: PropTypes.func,
      isOpen: PropTypes.bool
    }

    onEditCustomTemplate = () => {
      this.props.onEditCustomTemplate(
        {
          data: this.props.data,
          templateId: this.props.templateId
        },
        () => this.props.onCloseAfterSave());
    }

    render() {
      return (
        <Modal dialogClassName='confirm-cancel-save-eoc-template-dialog' show={this.props.isOpen} centered='true' size='sm'>
          {
            this.props.isSave &&
            <Modal.Header>
              <Modal.Title>Confirmation</Modal.Title>
            </Modal.Header>
          }
          <Modal.Body>
            {
              this.props.isSave
                ? <p>These changes only affect ESF forms created from this point onwards. All existing ESF forms will NOT inherit these changes.</p>
                : <p>Discard all changes ?</p>
            }
          </Modal.Body>
          <Modal.Footer>
            <div className='suspend-group-btn' style={{float: 'left'}}>
              <button className='btn btn-primary btn-siteone-default' onClick={this.props.onCancel}>Cancel</button>
              {
                this.props.isSave
                  ? <button style={{marginLeft: 10}} className='btn btn-primary btn-siteone' onClick={this.onEditCustomTemplate}>Save</button>
                  : <button style={{marginLeft: 10}} className='btn btn-primary btn-siteone' onClick={this.props.onOk}>OK</button>}
            </div>
          </Modal.Footer>
        </Modal>
      );
    }
}

export default ConfirmCancel;



// WEBPACK FOOTER //
// ./src/Projects/Components/Template/confirm-cancel.js